export default __webpack_public_path__ + "static/media/ZOO.a4a1f340.png";